if (typeof globalThis !== 'undefined') {
  const globalObject = globalThis as any;
  globalObject.__i18next_supportNoticeShown = true;

  const originalInfo = globalObject.console?.info;
  if (typeof originalInfo === 'function' && !globalObject.__ekos_i18next_info_filter_installed) {
    globalObject.__ekos_i18next_info_filter_installed = true;
    globalObject.console.info = (...args: unknown[]) => {
      const firstArg = String(args[0] || '');
      if (firstArg.includes('i18next is maintained with support from locize.com')) return;
      originalInfo.apply(globalObject.console, args);
    };
  }
}
